import './App.css';
import AllRouts from './Routs/AllRouts';

function App() {
  return (
    <div className="App">
     <AllRouts/>
    </div>
  );
}

export default App;